import type { ManualSpendEntry } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedMarketingSpend = PaginatedResponse<ManualSpendEntry>

export async function getMarketingSpend(
  params?: ListParams,
): Promise<PaginatedMarketingSpend> {
  const res = await api.get('/marketing-spend', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
